import { Sgke402aResponseLossyoteiChargeKeylst, Sgke402aResponseSearchresultList } from 'sg-api';

export class Sgke400dResultDto implements Sgke402aResponseSearchresultList {
  /** 欠損理由コード */
  lossRsncod: string;
  /** 支払契約番号 */
  payCtrNo: string;
  /** 請求先名 */
  visitName: string;
  /** 欠損判定区分コード */
  lossJudgmentDivcd: string;
  /** 欠損判定区分名称 */
  lossJudgmentdivisionAname: string;
  /** 承認依頼日 */
  apprvReqDate: string;
  /** 各地区承認日 */
  eachareaApprvDate: string;
  /** 欠損合計金額[円] */
  lossSumMny: number;
  /** 内ガス欠損金額[円] */
  inGasLossmny: number;
  /** 内電気欠損金額[円] */
  inElecLossmny: number;
  /** 内その他欠損金額[円] */
  inEtcLossmny: number;
  /** 欠損予定ステータスコード */
  lossyoteiStsCode: string;
  /** 欠損予定ステータスコード名称 */
  lossyoteiStsCodeaname: string;
  /** 請求契約まとめ区分コード */
  rcptfxMatomeDiv: string;
  /** 請求契約まとめ区分名称 */
  rcptfxMatomeDivAname: string;
  /** 督促管理区分コード */
  pressManagementdivisionCode: string;
  /** 督促管理区分名称 */
  pressmanagementdivisionAname: string;
  /** 督促担当地区コード */
  pressTantoAreacode: string;
  /** 督促担当地区名称 */
  pressInchargeregionAname: string;
  /** 料金区分コード */
  chargeDivcd: string;
  /** 料金区分名称 */
  chargedivisionAname: string;
  /** 閉栓日 */
  heisenDate: string;
  /** 閉栓理由コード */
  heisenReasonCode: string;
  /** 閉栓理由名称 */
  heisenReasonAname: string;
  /** 欠損予定料金キーリスト */
  lossyoteiChargeKeylst: Array<Sgke402aResponseLossyoteiChargeKeylst>;
  /** お客さま番号 */
  visitornumber: string;
  /** 承認 */
  checked: boolean;
  /** 変更前欠損理由コード */
  beforeLossRsncod: string;
  /** リクエスト対象 */
  get requestTarget(): boolean {

    let ret = false;

    // 承認依頼 かつ 欠損予定ステータスコードが'01'（欠損予定）
    ret ||= this.checked && this.lossyoteiStsCode == '01';

    // 承認依頼取消 かつ 欠損予定ステータスコードが'02'（欠損判定依頼）
    ret ||= !this.checked && this.lossyoteiStsCode == '02';

    // 承認依頼 かつ 欠損理由コード不一致
    ret ||= this.checked && this.lossRsncod != this.beforeLossRsncod;

    return ret;
  }

}
